import axios from "axios";
import _config from "@/config.js";
import mode from "@/mode.js";
import _alert from "./alert";
import store from "./store";
import router from "../router";
import moment from "moment";
const env = axios.create({
  baseURL: _config.server[mode]
  // headers: {
  //   "X-Requested-With": "XMLHttpRequest"
  // }
});
env.interceptors.request.use(
  config => {
    let token = JSON.parse(localStorage.getItem("_token")) || null;
    config.headers["Content-Type"] = "application/json";

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

env.interceptors.response.use(
  response => {
    return response;
  },
  function(error) {
    // Do something with response error
    if (error.response.status === 401) {
      localStorage.clear();
      router.push({ name: "login" });
      _alert.error(null, "Sesi Kadaluarsa", "Silahkan login kembali");
    } else if (error.response.status === 422) {
      _alert.error(error.response);
    } else if (error.response.status === 500) {
      _alert.error({}, "Error", "Terjadi kesalahan system");
    }
    return Promise.reject(error);
  }
);

const _service = {
  signOut() {
    localStorage.clear();
    router.push({ name: "login" });
    _alert.error(null, "Sesi Kadaluarsa", "Silahkan login kembali");
  },

  resetPassword(token, data) {
    return env
      .post(`/password/recovery`, data, {
        headers: {
          Authorization: token
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(err => {
        throw err.response;
      });
  },
  raw(method, endPoint, data) {
    return env[method](`${endPoint}`, data)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        throw err;
      });
  },
  post(endPoint, data) {
    return env
      .post(`${endPoint}`, data)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        throw err.response;
      });
  },
  put(endPoint, data) {
    return env
      .put(`${endPoint}`, data)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        throw err.response;
      });
  },
  patch(endPoint, data) {
    return env
      .patch(`${endPoint}`, data)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        throw err.response;
      });
  },
  get(endPoint, param) {
    if (param && param.filters) {
      Object.assign(param, param.filters);
      delete param.filters;
    }
    if (param && param.page && param.limit) {
      param.offset = param.page > 1 ? (param.page - 1) * param.limit : 0;
    }
    return env
      .get(`${endPoint}`, { params: param })
      .then(response => {
        return response.data;
      })
      .catch(err => {
        throw err.response;
      });
  },
  list(endPoint, param) {
    if (param && param.filters) {
      Object.assign(param, param.filters);
      delete param.filters;
    }
    if (param.page && param.limit) {
      param.offset = param.page > 1 ? (param.page - 1) * param.limit : 0;
    }

    return env
      .get(`${endPoint + ""}/list`, { params: param })
      .then(response => {
        return response.data;
      })
      .catch(err => {
        // if (err.response.status === 401) this.signOut()
        // else throw err.response
        throw err.response;
      });
  },
  dataset(endPoint, param) {
    if (param && param.filters) {
      Object.assign(param, param.filters);
      delete param.filters;
    }
    if (param && param.page && param.limit) {
      param.offset = param.page > 1 ? (param.page - 1) * param.limit : 0;
    }
    return env
      .get(`${endPoint}/dataset`, { params: param })
      .then(response => {
        return response.data;
      })
      .catch(err => {
        // if (err.response.status === 401) this.signOut()
        // else throw err.response
        throw err.response;
      });
  },
  single(endPoint, param, id) {
    console.log("id", id);
    if(id){
      if (param) endPoint += "?" + param;
      return env
        .get(
          `/${
            endPoint.charAt(0) === "/" ? `${endPoint.substring(1)}` : endPoint
          }` +
            "/" +
            id +
            "/show"
        )
        .then(response => {
          return response.data;
        })
        .catch(err => {
          // if (err.response.status === 401) this.signOut()
          // else throw err.response
          throw err.response;
        });
    }
  },
  create(endPoint, data) {
    return env
      .post(
        `${
          endPoint.charAt(0) === "/" ? `${endPoint.substring(1)}` : endPoint
        }/create`,
        data
      )
      .then(response => {
        return response.data;
      })
      .catch(err => {
        // if (err.response.status === 401) this.signOut()
        // else throw err.response
        throw err.response;
      });
  },
  update(endPoint, data) {
    // return env.put(`update/${endPoint}`, data).then(response => {
    return env
      .put(
        `${
          endPoint.charAt(0) === "/" ? `${endPoint.substring(1)}` : endPoint
        }/update`,
        data
      )
      .then(response => {
        return response.data;
      })
      .catch(err => {
        // if (err.response.status === 401) this.signOut()
        // else throw err.response
        throw err.response;
      });
  },
  // delete(endPoint, data) {
  //   return env
  //     .delete(
  //       `${
  //         endPoint.charAt(0) === "/" ? `${endPoint.substring(1)}` : endPoint
  //       }/delete`,
  //       {id: data.id}
  //     )
  //     .then(response => {
  //       return response.data;
  //     })
  //     .catch(err => {
  //       // if (err.response.status === 401) this.signOut()
  //       // else throw err.response
  //       throw err.response;
  //     });
  // },
  delete(endPoint, data) {
    const cleanEndPoint = endPoint.charAt(0) === "/" ? endPoint.substring(1) : endPoint;

    let payload = {};

    if (data && typeof data === 'object') {
      if ('id' in data) {
        payload = { id: data.id };
      } else if ('code' in data) {
        payload = { code: data.code };
      } else {
        payload = data;
      }
    }

    return env
      .delete(`${cleanEndPoint}/delete`, {
        headers: { 'Content-Type': 'application/json' },
        data: payload
      })
      .then(response => response.data)
      .catch(err => {
        throw err.response || err;
      });
  },
  fileUpload(file, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return env
      .post("upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress
      })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        // if (err.response.status === 401) this.signOut()
        // else throw err.response
        throw err.response;
      });
  },

  export(path, params) {
    return env
      .get(path, {
        responseType: "blob",
        params: params
      })
      .then(res => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement("a");
        var date = moment().format("D MMM YYYY");
        if (params.date) {
          if (
            Array.isArray(params.date) &&
            params.date.length > 0 &&
            moment(params.date[0], "YYYY-MM-DD").isValid()
          ) {
            date = moment(params.date[0], "YYYY-MM-DD").format("D MMM YYYY");
          } else if (moment(params.date, "YYYY-MM-DD").isValid()) {
            date = moment(params.date, "YYYY-MM-DD").format("D MMM YYYY");
          } else {
          }
        }
        var fileName = `${path
          .split("/")
          [path.split("/").length - 1].split("-")
          .map(s => s.charAt(0).toUpperCase() + s.substring(1))
          .join(" ")} ${date}.xlsx`;

        fileLink.href = fileURL;
        fileLink.setAttribute("download", fileName);
        document.body.appendChild(fileLink);

        fileLink.click();
        return res.data;
      })
      .catch(err => {
        throw err.response;
      });
  }
};

export default _service;



// WEBPACK FOOTER //
// ./src/utils/service.js